import { suppressPDPCancelSurvey } from "@components/pdpCancelSurvey";
import Globals from "globals";
import Network from "network";
import { useCallback, useMemo } from "react";
import { ID } from "types/ID";
import { frequencyFor } from "./lib";
import { IPDPContentProps } from "./pdpContent";
import { Products } from "./products";
import { FreeTrialDuration, IProduct } from "./types";
import useProducts from "./useProducts";

export interface IStripeCheckoutResponse {
  url: string;
  eligible_for_free_trial?: boolean;
}

export const stripeFreeTrialDuration: FreeTrialDuration = "1 week";

export async function fetchStripeCheckoutInfo(
  email: string,
  userID: ID,
  productID: string,
  experiment?: unknown,
): Promise<IStripeCheckoutResponse> {
  const checkoutData = {
    product_id: productID,
    client_version: Globals.version,
    email,
    user_id: userID,
    experiment,
  };
  const response = await Network.fetch<IStripeCheckoutResponse>(
    "POST",
    "/users/purchases/stripe/checkout",
    checkoutData,
  );
  return response;
}

interface IProps extends IPDPContentProps {
  onPurchaseComplete: () => void;
}
export default function WebPDPContent({
  userID,
  email,
  logger,
  reason,
  onPurchaseComplete,
  dismiss,
}: IProps) {
  const productsState = useProducts(email, logger);
  const { val: serverProducts } = productsState;

  const handlePurchase = useCallback(
    async (product: IProduct) => {
      logger.log("offsite_checkout_initiated", { product });
      suppressPDPCancelSurvey();
      dismiss();

      onPurchaseComplete();
    },
    [logger, dismiss, onPurchaseComplete],
  );

  const prods: IProduct[] = useMemo(() => {
    return (serverProducts ?? []).map((prod) => {
      return {
        ...prod,
        frequency: frequencyFor(prod.id),
      };
    });
  }, [serverProducts]);

  return (
    <Products
      reason={reason}
      onPurchase={handlePurchase}
      products={prods}
      productsLoading={serverProducts === undefined}
      gateway="stripe"
      userID={userID}
      email={email}
      logger={logger}
    />
  );
}
